// extracted by mini-css-extract-plugin
module.exports = {"tabbedNav":"tabRaces_tabbedNav__1Oglt","selected":"tabRaces_selected__1NKPD","inputs":"tabRaces_inputs__3Ln2l"};